import { render } from "./CabeceraComponent.vue?vue&type=template&id=e2b8cd24&scoped=true"
import script from "./CabeceraComponent.vue?vue&type=script&lang=js"
export * from "./CabeceraComponent.vue?vue&type=script&lang=js"

import "./CabeceraComponent.vue?vue&type=style&index=0&id=e2b8cd24&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b8cd24"]])

export default __exports__